import { render, staticRenderFns } from "./RoomRepartition.vue?vue&type=template&id=0d98d94d"
import script from "./RoomRepartition.vue?vue&type=script&lang=js"
export * from "./RoomRepartition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports